import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import DATA_CY from 'constants/data-cy';
import { Button, Modal, ModalText } from './styled';

const modalTypeInfo = {
  post: {
    title: 'Post',
    text: 'Are you sure want to delete this post?\nThis action can’t be undone',
  },
  comment: {
    title: 'Comment',
    text: 'Are you sure want to delete this comment?\nThis action can’t be undone',
  },
};

interface ModalDeleteAuthorProps {
  onCancel: () => void;
  visible: boolean;
  handleDelete: () => Promise<void>;
  type: 'post' | 'comment';
}

function ModalDeleteAuthor({
  onCancel,
  visible,
  handleDelete,
  type,
}: ModalDeleteAuthorProps) {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={
        <Text size="20px" height="54px" family="bold">
          Delete {modalTypeInfo[type]?.title}
        </Text>
      }
      closeIcon={null}
      footer={[
        <Button
          key="cancel"
          block
          height="40px"
          onClick={onCancel}
          data-cy={DATA_CY.STREAM_POST.CONFIRM_CANCEL_BUTTON}
        >
          <Text align="center" family="bold">
            Cancel
          </Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="secondary"
          height="40px"
          onClick={handleDelete}
          data-cy={DATA_CY.STREAM_POST.CONFIRM_DELETE_BUTTON}
        >
          <Text align="center" family="bold" color={color.light}>
            Delete
          </Text>
        </Button>,
      ]}
      transitionName=""
      maskTransitionName=""
    >
      <ModalText size="14px" height="19px" align="center">
        {modalTypeInfo[type]?.text}
      </ModalText>
    </Modal>
  );
}

export default ModalDeleteAuthor;
